import { useEffect, useState } from 'react';

// Fires immediately post-hydration, well before any page data-load cycle completes
const useIsClient = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsClient(true);
  }, []);

  return isClient;
};

export default useIsClient;
